import { Form, FormItem } from '@/components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
`;

export const FormColumn = styled.div`
  flex-direction: column;
  gap: 1rem;
  display: flex;
`;

export const StyledForm = styled(Form)`
  justify-content: space-between;
  height: 100%;
`;

export const StyledHeader = styled.div`
  display: flex;
  padding: 1rem 2rem;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid ${COLORS.LIGHT_GRAY};
`;

export const StyledButton = styled(Button)`
  &&& {
    width: 100%;
    min-height: 3rem;
    margin: 1rem 0;
    ${pickThemeFontStyles('14', '18', 'BOLD')};
  }
`;

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
  text-align: left;
  margin: 0;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  padding: 1.5rem 2rem;
  flex-direction: column;
`;

export const StyledActionButton = styled(Button)<{ $color: string }>`
  &&& {
    background: ${({ $color }) => $color};
    padding: 0.25rem;
    border: none;
    width: 2.125rem;
    height: 2.125rem;

    :hover {
      background: ${({ $color }) => $color};
    }
  }

  svg {
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
  margin-bottom: 2rem;
`;

export const StyledTabContainer = styled.div`
  .ant-tabs-nav {
    margin: 0;
    width: fit-content;

    .ant-tabs-nav-wrap {
      background-color: transparent;
      overflow: hidden;
      width: fit-content;
    }

    .ant-tabs-nav-list {
      width: 100%;
    }

    .ant-tabs-ink-bar {
      background: ${COLORS.YELLOW_PRIMARY};
    }

    .ant-tabs-tab {
      margin: 0;
      padding: 0.6875rem 1rem;
      ${pickThemeFontStyles('14', '16', 'SMALL')};
      color: ${COLORS.CHARCOAL};
      letter-spacing: 0.0125rem;
      background: transparent;
      transition: all 0.2s ease-in-out;
      min-height: 2.6875rem;

      &:hover {
        background: ${COLORS.YELLOW_PRIMARY};
      }

      &.ant-tabs-tab-active {
        background: transparent;
        padding: 0.8125rem 1rem;
        ${pickThemeFontStyles('15', '16', 'SEMI_BOLD')};

        .ant-tabs-tab-btn {
          color: ${COLORS.BLACK_PRIMARY};
          letter-spacing: normal;
        }

        &:hover {
          background: ${COLORS.YELLOW_PRIMARY};
        }
      }
    }

    &::before {
      display: none !important;
    }
  }

  .ant-tabs-content-holder {
    background: ${COLORS.GRAY};
    padding: 2rem 1rem;
  }

  &&& input {
    min-height: 2.8125rem;
  }

  /* &&& textarea {
    min-height: 24.625rem;
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    &&& textarea {
      min-height: 7.5rem;
    }
  } */
`;

export const StyledFormItem = styled(FormItem)`
  &&& .ant-form-item-label {
    padding: 0;

    label {
      ${pickThemeFontStyles('12', '18', 'NORMAL')};
      color: ${COLORS.GRAY_MEDIUM};
      margin: 0 0 0.1rem;
    }
  }

  &&& textarea {
    resize: none;
  }

  min-height: 2.8125rem;
`;
